import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { roleToRedirectPath } from '../../lib/auth';
import { useAuth } from '../../context/AuthContext';
import type { UiRole } from '../../lib/roles';

export default function ProtectedRoute({
  children,
  allow,
}: {
  children: React.ReactElement;
  allow?: UiRole[];
}) {
  const location = useLocation();
  const { me, uiRole, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!me || !uiRole) {
    return <Navigate to="/authentication-portal" state={{ from: location.pathname }} replace />;
  }

  if (allow && !allow.includes(uiRole)) {
    return <Navigate to={roleToRedirectPath(me.role)} replace />;
  }

  return children;
}

